<div #container>
    <div class="card-header">
        <h4 class="card-header-title">
            <img src="assets/images/icons/euro.png" width="20px" class="me-2">
            Costs
        </h4>
        <app-chart-download-button *ngIf="!showInReport" [element]="container"></app-chart-download-button>
    </div>
    <div class="card-body pt-0">
        <ng-container *ngIf="this.showChart else loadingSkeleton">
            <app-doughnut-chart class="chart chart-appended h-100 d-flex align-items-center justify-content-center"
                            [doughnutText]="'€ ' + (totalCosts | number)"
                            [dataProvider]="dataProvider" [height]="300"
                            [animationDuration]="showInReport ? 0 : 1000"
                            [withCircumference]="true"></app-doughnut-chart>
        </ng-container>
        <ng-template #loadingSkeleton>
            <div *ngIf="!showInReport"  class="pt-5">
                   <ngx-skeleton-loader count="1" [appearance]="'line'"
                                        [theme]="{ height: '250px', 'border-radius': '0.25rem' }">
                   </ngx-skeleton-loader>
            </div>
        </ng-template>
    </div>
</div>
